const template=`
<div class="volumeWidget">
  <widget-status></widget-status>
  <div>
    <h3 class="widgetNoResultsLabel translate" ng-show="noContent &amp;&amp; !widgetIsLoading">No results</h3>
    <h3 class="widgetNoResultsLabel translate" ng-show="noWidgetContent &amp;&amp; !widgetIsLoading &amp;&amp; !showTable">Oh no! Your widget didn't load.</h3>
    <h3 class="widgetNoResultsLabel translate" ng-show="noWidgetContent &amp;&amp; !widgetIsLoading &amp;&amp; !showTable">Either we cannot support your filters or please try to refresh the page.</h3>
  </div>
  <bubble-d3 class="bubble" data="chartData" chart-type="graphType" selected="selectedNodes" drill="drill(id)" maximized="isMaximized" data-ng-hide="widgetIsLoading || serviceError || noContent || noWidgetContent || notConfigured"></bubble-d3>
</div>`;
export default template;
